export const removeTextKey = _TL_('Remove');
